// src/pages/admin/AdminContacts.jsx
import React, { useEffect, useState } from "react";
import { getContacts, markContactRead, deleteContact } from "../../services/firestoreService";
import Spinner from "../../components/common/Spinner";
import Modal from "../../components/common/Modal";
import { format } from "date-fns";
import { FiTrash2, FiMail, FiInbox } from "react-icons/fi";
import toast from "react-hot-toast";

export default function AdminContacts() {
  const [contacts, setContacts] = useState([]);
  const [loading,  setLoading]  = useState(true);
  const [selected, setSelected] = useState(null);

  const load = async () => {
    const c = await getContacts();
    setContacts(c);
    setLoading(false);
  };
  useEffect(() => { load(); }, []);

  const handleOpen = async (contact) => {
    setSelected(contact);
    if (!contact.read) {
      await markContactRead(contact.id);
      setContacts((prev) => prev.map((c) => c.id === contact.id ? { ...c, read: true } : c));
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this message?")) return;
    await deleteContact(id);
    toast.success("Message deleted");
    setContacts((prev) => prev.filter((c) => c.id !== id));
    setSelected(null);
  };

  const unread = contacts.filter((c) => !c.read).length;

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Contact Inquiries</h1>
          {unread > 0 && <p className="text-sm text-primary-600 font-medium mt-0.5">{unread} unread message{unread !== 1 ? "s" : ""}</p>}
        </div>
      </div>

      {loading ? <Spinner center /> : (
        <div className="card overflow-hidden">
          {contacts.length === 0 ? (
            <div className="text-center py-16 text-gray-500">
              <FiMail className="w-12 h-12 mx-auto text-gray-300 mb-3" />
              <p>No contact inquiries yet.</p>
            </div>
          ) : (
            <table className="w-full text-sm">
              <thead className="bg-gray-50 border-b border-gray-200">
                <tr>
                  {["", "Name", "Email", "Subject", "Date", "Actions"].map((h) => (
                    <th key={h} className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wide">{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {contacts.map((contact) => (
                  <tr key={contact.id} className={`hover:bg-gray-50 cursor-pointer ${!contact.read ? "bg-primary-50/30" : ""}`} onClick={() => handleOpen(contact)}>
                    <td className="px-3 py-3">
                      {contact.read ? (
                        <FiInbox className="w-4 h-4 text-gray-400" />
                      ) : (
                        <div className="w-2.5 h-2.5 rounded-full bg-primary-600" />
                      )}
                    </td>
                    <td className="px-4 py-3 font-medium text-gray-900">{contact.name}</td>
                    <td className="px-4 py-3 text-gray-600">{contact.email}</td>
                    <td className="px-4 py-3 text-gray-700 max-w-xs">
                      <p className={`truncate ${!contact.read ? "font-semibold" : ""}`}>{contact.subject}</p>
                    </td>
                    <td className="px-4 py-3 text-gray-500 whitespace-nowrap">
                      {contact.createdAt?.toDate ? format(contact.createdAt.toDate(), "dd MMM, hh:mm a") : "—"}
                    </td>
                    <td className="px-4 py-3" onClick={(e) => e.stopPropagation()}>
                      <button onClick={() => handleDelete(contact.id)} className="p-1.5 rounded-lg hover:bg-red-50 text-red-500 transition-colors">
                        <FiTrash2 className="w-4 h-4" />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}

      {/* Message detail modal */}
      <Modal isOpen={!!selected} onClose={() => setSelected(null)} title="Contact Message">
        {selected && (
          <div className="space-y-4">
            <div className="grid grid-cols-2 gap-4 text-sm">
              <div><span className="text-gray-500">Name:</span><span className="font-medium ml-2">{selected.name}</span></div>
              <div><span className="text-gray-500">Phone:</span><span className="font-medium ml-2">{selected.phone || "—"}</span></div>
              <div className="col-span-2"><span className="text-gray-500">Email:</span><a href={`mailto:${selected.email}`} className="font-medium ml-2 text-primary-600 hover:underline">{selected.email}</a></div>
              <div className="col-span-2"><span className="text-gray-500">Date:</span><span className="ml-2">{selected.createdAt?.toDate ? format(selected.createdAt.toDate(), "dd MMMM yyyy, hh:mm a") : "—"}</span></div>
            </div>
            <div>
              <p className="text-sm font-semibold text-gray-700 mb-1">Subject</p>
              <p className="text-gray-900 bg-gray-50 rounded-lg p-3">{selected.subject}</p>
            </div>
            <div>
              <p className="text-sm font-semibold text-gray-700 mb-1">Message</p>
              <p className="text-gray-700 bg-gray-50 rounded-lg p-3 whitespace-pre-wrap leading-relaxed">{selected.message}</p>
            </div>
            <div className="flex gap-3 pt-2">
              <a href={`mailto:${selected.email}?subject=Re: ${selected.subject}`} className="btn-primary flex-1 text-center">
                Reply via Email
              </a>
              <button onClick={() => handleDelete(selected.id)} className="btn-danger flex items-center gap-2">
                <FiTrash2 className="w-4 h-4" /> Delete
              </button>
            </div>
          </div>
        )}
      </Modal>
    </div>
  );
}
